import React, {Component} from 'react'
import {connect} from 'react-redux'
import cls from 'classnames'

import Sticker from '../../components/Sticker/Sticker'
import OpenButton from '../../components/Button/Button'
import DeleteButton from '../../components/Button/Button'
import UrlListComponent from '../../components/UrlList/UrlList'
import ContentColumn from '../../components/GridColumn/GridColumn'
import SidebarColumn from '../../components/GridColumn/GridColumn'

import {
	saveUrlList,
	saveSelectedUrlList,
	updateUrlList,
	deleteUrlList,
	deleteSelectedUrlList
} from '../../store/actions/storage'

import {getUrlListfromString} from '../../utils/utils'
import classes from './UrlList.module.scss'

class UrlList extends Component {
	componentDidMount() {
		document.onselectionchange = this.onSelectionChange
	}

	componentWillUnmount() {
		document.onselectionchange = null
	}

	onSelectionChange = () => {
		const selectedUrlList = getUrlListfromString(document.getSelection().toString())

		if (selectedUrlList.length) {
			const urlList = this.props.urlList.map(item => item.url)

			this.props.saveSelectedUrlList(selectedUrlList.filter(url => urlList.includes(url)))
		} else {
			this.props.deleteSelectedUrlList()
		}
	}

	markUrlAsSelected = (url) => {
		this.props.updateUrlList([url])
	}

	openSelectedUrls = () => {
		const urlList = this.props.selectedUrlList.length
			? this.props.selectedUrlList
			: this.props.urlList.map(item => item.url)

		urlList.forEach(url => {
			window.open(url, '_blank')
		})

		this.props.updateUrlList(urlList)
		this.props.deleteSelectedUrlList()

		if (window.getSelection) {
			if (window.getSelection().empty) {
				window.getSelection().empty()
			} else if (window.getSelection().removeAllRanges) {
				window.getSelection().removeAllRanges()
			}
		} else if (document.selection) {
			document.selection.empty()
		}
	}

	deleteUrlList = () => {
		this.props.deleteUrlList()
		this.props.deleteSelectedUrlList()
	}

	render() {
		return (
			<React.Fragment>
				<div className='row'>
					{
						!!this.props.urlList.length
							? <React.Fragment>
								<ContentColumn
									size={9}
									className={classes.UrlList__column}
								>
									<span
										className={classes['UrlList__sub-title']}
									>
										List of submitted urls:
									</span>
									<UrlListComponent
										urlList={this.props.urlList}
										onLinkClick={this.markUrlAsSelected}
									/>
								</ContentColumn>
								<SidebarColumn
									size={3}
									alignContent='center'
								>
									<Sticker
										className={classes.UrlList__sticker}
									>
										<OpenButton
											label={!!this.props.selectedUrlList.length
												? `Open selected (${this.props.selectedUrlList.length})`
												: 'Open all'
											}
											className={cls('btn-primary', classes['UrlList__open-button'])}
											onClick={this.openSelectedUrls}
										/>
										<DeleteButton
											label='Delete all'
											className={cls('btn-danger', classes['UrlList__delete-button'])}
											onClick={this.deleteUrlList}
										/>
									</Sticker>
								</SidebarColumn>
							</React.Fragment>
							: <ContentColumn>
								<span
									className={classes['UrlList__no-links']}
								>
									There are no urls yet :(
								</span>
							</ContentColumn>
					}
				</div>
			</React.Fragment>
		)
	}
}

const mapStateToProps = state => ({
	urlList: state.storage.urlList,
	selectedUrlList: state.storage.selectedUrlList
})

const mapDispatchToProps = dispatch => ({
	saveUrlList: urlList => dispatch(saveUrlList(urlList)),
	saveSelectedUrlList: urlList => dispatch(saveSelectedUrlList(urlList)),
	updateUrlList: urlList => dispatch(updateUrlList(urlList)),
	deleteUrlList: () => dispatch(deleteUrlList()),
	deleteSelectedUrlList: () => dispatch(deleteSelectedUrlList())
})

export default connect(mapStateToProps, mapDispatchToProps)(UrlList)